import { render, staticRenderFns } from "./RequiredFieldsDetail.vue?vue&type=template&id=62b52ccb&scoped=true"
import script from "./RequiredFieldsDetail.vue?vue&type=script&lang=js"
export * from "./RequiredFieldsDetail.vue?vue&type=script&lang=js"
import style0 from "./RequiredFieldsDetail.vue?vue&type=style&index=0&id=62b52ccb&prod&scoped=true&lang=css"
import style1 from "./RequiredFieldsDetail.vue?vue&type=style&index=1&id=62b52ccb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b52ccb",
  null
  
)

export default component.exports